function writingActive({ formatG, pearsonWritingActive, pearsonWriting, pearsonWritingItem } = {}) {
  return Boolean(formatG || pearsonWritingActive || pearsonWriting || pearsonWritingItem);
}

/** Navigator / toolbar: omit Flag for TARA writing Pearson or BMAT writing. No isPostExam. */
export function hidePearsonWritingFlagNavigator({
  formatG,
  pearsonWritingActive,
  pearsonWriting,
  pearsonWritingItem,
  bmatSitting,
  moduleKey,
} = {}) {
  return Boolean(
    writingActive({ formatG, pearsonWritingActive, pearsonWriting, pearsonWritingItem })
    || (bmatSitting && moduleKey === 'writing')
  );
}

/** Review table: BMAT writing omits Flagged even after lock; TARA writing Pearson only before lock. */
export function hidePearsonWritingFlagReview({
  formatG,
  pearsonWritingActive,
  pearsonWriting,
  pearsonWritingItem,
  bmatSitting,
  moduleKey,
  isPostExam,
} = {}) {
  return Boolean(
    (bmatSitting && moduleKey === 'writing')
    || (!isPostExam && writingActive({ formatG, pearsonWritingActive, pearsonWriting, pearsonWritingItem }))
  );
}
